import { Log } from '@/shared/Log';
import { Utils } from '@/shared/Utils';

import { R, format } from '@/caregiverSpace/resources/Texts.resx';

import { ICaregiverConsultationDto } from '../model/types';

export const hasNew = (firstList: string[], secondList: string[]) => {
    if (secondList.length === 0) {
        return false;
    }
    for (const element of secondList) {
        if (!firstList.includes(element)) {
            return true;
        }
    }
    return false;
};

const showNewConsultationNotification = () => {
    showNotification(format(R.NewConsultation, Utils.formatTime(new Date())));
};

export const showNotification = (message: string) => {
    if (!('Notification' in window)) {
        return;
    }

    if (Notification.permission !== 'granted') {
        return;
    }

    const notification = new Notification(message, {
        body: R.PatientWaitingRoom,
        icon: '/favicons/android-chrome-192x192.png',
        tag: 'video',
        renotify: true,
    });
    notification.onshow = (e) => {
        Log.info('notification.onshow: ' + new Date(), e);
    };
    notification.onclose = (e) => {
        Log.info('notification.onclose:' + new Date(), e);
    };
    setTimeout(() => {
        notification.close();
        Log.info('close', new Date());
    }, 14000);
};

export const requestPermissionToShowNotifications = () => {
    if (!('Notification' in window)) {
        Log.info('This browser does not support system notifications');
        return;
    }

    if (Notification.permission === 'granted') {
        return;
    }

    const onPermissionRequested = (permission: NotificationPermission) => {
        if (permission !== 'granted') {
            return;
        }
        const notification = new Notification(R.ThankYou, {
            body: R.BookingMessage,
            icon: '/favicons/android-chrome-192x192.png',
        });
        setTimeout(notification.close.bind(notification), 15000);
    };

    try {
        Notification.requestPermission()
            .then(onPermissionRequested)
            .catch((e) => {
                Log.error('Notifications permission denied', e);
            });
    } catch (error) {
        // Safari doesn't return a promise for requestPermissions and it
        // throws a TypeError. It takes a callback as the first argument
        // instead.
        if (error instanceof TypeError) {
            Notification.requestPermission(onPermissionRequested);
        } else {
            throw error;
        }
    }
};

export const notifyNewConsultation = (
    existingConsultations: ICaregiverConsultationDto[],
    consultations: ICaregiverConsultationDto[],
    isSoundDisabled: boolean,
    isCallOpened: boolean,
    caregiverId: number,
) => {
    const sound = document.getElementById('pendingSound') as HTMLAudioElement;
    if (!consultations) {
        Log.info(
            'NEW Waiting list: notifyNewConsultation: Response must be an array',
            consultations,
        );
        return;
    }
    if (
        hasNew(
            existingConsultations
                .filter((x) => x.IsInWaitingRoom)
                .map((x) => x.Uid),
            consultations
                .filter(
                    (x) =>
                        x.IsInWaitingRoom &&
                        (x.AssignedCaregiver === null ||
                            x.AssignedCaregiver?.UserId === caregiverId),
                )
                .map((x) => x.Uid),
        )
    ) {
        showNewConsultationNotification();
        if (!isSoundDisabled && !isCallOpened) {
            Promise.resolve()
                .then(() => sound.play())
                .catch((reason: any) => {
                    // typically this fails because the user didn't interact with the document first
                    Log.info('Could not play sound. reason: ', reason);
                });
        }
    }
};
